import { IBulkCard, IBulkCardReportDownload } from '@/features/cards/store/models/bulk-card.model';

import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';

import { get } from '@/services/FetchServices';

export class BulkCardService {
  static queryKey = 'BulkCard';
  static getBulkCards = async (): Promise<IBulkCard[]> => {
    try {
      const config = getStaticDashboardConfig();

      return await get(
        { url: `${config.api.baseUrl}/core-connect/card/bulk`, action: this.queryKey },
        { shouldSkipEncryption: true },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
  static createBulkCard = async (bulkCardRequest: IBulkCard): Promise<IBulkCard> => {
    try {
      const config = getStaticDashboardConfig();

      return await get(
        {
          url: `${config.api.baseUrl}/core-connect/card/bulk`,
          method: 'POST',
          body: bulkCardRequest,
          action: this.queryKey,
        },
        { shouldSkipEncryption: true, isSingle: true },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
  static getBulkCardReport = async (orderId: string): Promise<IBulkCardReportDownload> => {
    try {
      const config = getStaticDashboardConfig();

      return await get(
        {
          url: `${config.api.baseUrl}/core-connect/card/bulk/${orderId}/report`,
          contentType: 'text/csv',
          action: this.queryKey,
        },
        { shouldSkipEncryption: true, isSingle: true },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
